import Vue            from 'vue'
import Router         from 'vue-router'
import axios          from 'axios'
import VueAxios       from 'vue-axios'
import Notifications  from 'vue-notification'
// import viewDashboard  from '@/views/view_dashboard'
import ViewCirugiaForm       from '@/views/v_cirugia_form'
import ViewCirugiaList       from '@/views/v_cirugia_list'
import ViewGastoForm       from '@/views/v_gasto_form'
import ViewGastoList       from '@/views/v_gasto_list'
import infiniteScroll from 'vue-infinite-scroll'
import { mixin as clickaway } from 'vue-clickaway'
import VueGoogleCharts from 'vue-google-charts'
import moment from 'moment'
moment.locale('es')

Vue.use(Notifications)
Vue.use(VueGoogleCharts)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(require('@websanova/vue-upload'))
Vue.axios.defaults.baseURL = process.env.API_ROUTE
Vue.mixin(clickaway)
Vue.use(require('vue-shortkey'))
Vue.use(infiniteScroll)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'view-dashboard',
      component: ViewCirugiaList
    },
    {
      path: '/cirugias',
      name: 'view-cirugia-list',
      component: ViewCirugiaList
    },
    {
      path: '/cirugia/:_id?',
      name: 'view-cirugia-form',
      component: ViewCirugiaForm,
      props: true
    },
    {
      path: '/gastos',
      name: 'view-gasto-list',
      component: ViewGastoList
    },
    {
      path: '/gasto/:_id?',
      name: 'view-gasto-form',
      component: ViewGastoForm,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/admin.js